// Global
import "./modules/bootstrap";
import "./modules/theme";
import "./modules/dragula";
import "./modules/feather";
import "./modules/moment";
import "./modules/sidebar";
import "./modules/toastr";
import "./modules/user-agent";

// Charts
import "./modules/chartjs";
import "./modules/apexcharts";

// Forms
import "./modules/daterangepicker";
import "./modules/datetimepicker";
import "./modules/fullcalendar";
import "./modules/markdown";
import "./modules/mask";
import "./modules/quill";
import "./modules/select2";
import "./modules/validation";
import "./modules/wizard";
import "./modules/nouislider";

// Maps
import "./modules/vector-maps";

// Tables
import "./modules/datatables";

// Custom Modules
// THESE MIGHT BE ERASED BY UPDATING APPSTACK
// MAKE SURE TO CHECK GIT CHANGES DURING UPDATES
import MultiSelectTransfer from './modules/multiSelectTransfer';
window.MultiSelectTransfer = MultiSelectTransfer;